import { toast } from "react-toastify";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";

export const FetchUserChatAction = (data) => {
  return {
    type: "fetch_user_chat",
    payload: data,
    loader: false,
  };
};

export const AddChatMessageAction = (data) => {
  return {
    type: "add_chat_message",
    payload: data,
    loader: false,
  };
};

export const ClearChatAction = () => {
  return {
    type: "clear_chat",
    loader: false,
  };
};

// Fetch chat history with pagination support
// pageNumber=1 replaces messages; pageNumber>1 prepends older messages
export function fetchUserChatHistory(pageNumber = 1, pageSize = 10) {
  return async (dispatch) => {
    try {
      const result = await axiosInstanceAuth.get(
        `/AiAgent/GetAIAgentChats?Module=${"ERP"}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      );

      if (result.data?.IsSuccess === true) {
        if (pageNumber > 1) {
          // Prepend older messages
          dispatch({
            type: "fetch_user_chat_append",
            payload: result.data,
            loader: false,
          });
        } else {
          dispatch(FetchUserChatAction(result.data));
        }
      } else {
        toast.error(result.data?.Message || "Failed to fetch chat history");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong!");
    }
  };
}

// Send message to AI Agent
export async function sendChatMessage(question, module = "ERP") {
  try {
    const result = await axiosInstanceAuth.post("/AiAgent/ask", {
      question,
      module,
    });

    if (result?.data?.answer) {
      return {
        success: true,
        data: result?.data,
        message: result?.data?.answer,
      };
    } else {
      return {
        success: false,
        message: result?.data?.Message || "Failed to send message",
      };
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.Message || "Something went wrong!";
    toast.error(errorMsg);
    return {
      success: false,
      message: errorMsg,
    };
  }
}
